export interface VenueOnlineProps {
  // add props here
}

export const clearInputFieldId = 'clear';
export const copyInputFieldId = 'copy';

export const getOnlineVenueErrorText = (onlineVenueURL?: string): string => {
  if (!onlineVenueURL) {
    return window.i18next.t('pmwjs_please_add_an_event_link');
  }
  return window.i18next.t('pmwjs_please_add_valid_link');
};
